export function initNav() {
  const toggle = document.querySelector(".nav-toggle");
  const nav = document.querySelector(".site-nav");

  if (!toggle || !nav) return;

  const setOpen = (open) => {
    nav.dataset.collapsed = open ? "false" : "true";
    toggle.setAttribute("aria-expanded", open ? "true" : "false");
  };

  toggle.addEventListener("click", () => {
    const isCollapsed = nav.dataset.collapsed !== "false";
    setOpen(isCollapsed);
  });

  // Close when clicking a nav link (mobile convenience)
  nav.addEventListener("click", (e) => {
    const link = e.target.closest("a");
    if (link) setOpen(false);
  });

  // Close on Escape
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") setOpen(false);
  });

  // Set aria-current="page" on the current page's nav link
  setCurrentPageIndicator();
}

function setCurrentPageIndicator() {
  const normalizePath = (path) => {
    // Remove trailing slash and normalize index.html to root
    let normalized = path.replace(/\/$/, '') || '/';
    if (normalized.endsWith('/index.html') || normalized.endsWith('index.html')) {
      normalized = '/';
    }
    return normalized;
  };

  const currentPath = normalizePath(window.location.pathname);
  const navLinks = document.querySelectorAll(".nav-link");

  navLinks.forEach((link) => {
    const url = new URL(link.href, window.location.href);
    if (url.origin !== window.location.origin) {
      return;
    }
    const linkPath = normalizePath(url.pathname);
    if (linkPath === currentPath) {
      link.setAttribute("aria-current", "page");
    }
  });
}
